import React from 'react';
// @ts-ignore
import { useBranch } from 'baobab-react/hooks';
import * as baobab from '@data/baobab/baobab';
import { Loading, LoadingWrap } from '@styled/Basic';
export function GlobalLoading() {
    var loading = useBranch({
        loading: ['state', 'globalLoading'],
    }).loading;
    if (loading > 0) {
        return (React.createElement(LoadingWrap, { "$dimBg": true },
            React.createElement(Loading, { "$size": 2 })));
    }
    else {
        return null;
    }
}
export function startGlobalLoading() {
    baobab.root.select('state', 'globalLoading').apply(function (prev) { return prev + 1; });
    baobab.root.commit();
}
export function stopGlobalLoading() {
    baobab.root.select('state', 'globalLoading').apply(function (prev) { return prev - 1; });
    baobab.root.commit();
}
